<template>
    <v-dialog
        v-model="localDialog"
        max-width="500px">
        <v-card>
            <v-card-title
                class="font-weight-bold oxygen fs-24"
                :style="`border-top: 4px solid ${$vuetify.theme.themes.light.accent2}`"
                :class="{
                    'caption mobile-title': isMobilePort
                    }">
                    <v-icon
                        class="mr-2"
                        color="accent2">
                        mdi-creation
                    </v-icon>
                    Unlock AI Navigator
                <v-spacer></v-spacer>
                <v-icon
                    class="black--text"
                    @click="localDialog = false">
                    close
                </v-icon>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0 pb-2">
                <v-row class="grey lighten-4 pa-0 ma-0">
                    <v-col class="text-center pa-0">
                        <img
                            class="section-img"
                            alt="AIN marketing"
                            :src="asset(require('../../images/premium_tools/ain-marketing-image.png'), 'default')"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <p class="overflow-hidden text-center pa-3 body-1">
                            <b>Save hours on code research.</b> Ask a question or summarize any section in seconds—AI Navigator 
                            keeps your projects moving and your time focused where it matters.
                        </p>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col class="text-right mr-3">
                        <v-btn
                            depressed
                            color="accent2"
                            class="font-weight-bold"
                            @click="openSubscribeToPremiumDialog()"
                        >
                        Subscribe To Premium
                        </v-btn>
                    </v-col>
                 </v-row>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import Mobile from '../inc/mixins/mobile'

    export default {
        data() {
            return {
                localDialog: this.isDialogActive
            }
        },
        props: {
            isDialogActive: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        watch: {
            isDialogActive(val) {
                this.localDialog = val
            },
            // emit change back to parent when local changes
            localDialog(val) {
                this.$emit('update:isDialogActive', val)
            },
        },
        mixins: [
            Mobile
        ],
        computed: {
            documentInfo() {
                return this.$store.getters.getDocumentInfo;
            }
        },
        methods: {
            openSubscribeToPremiumDialog() {
                this.localDialog = !this.localDialog;
                EventBus.fire('show-premium-subscribe-dialog', this.documentInfo);
            }
        }
    }
</script>
<style lang="scss" scoped>
    .section-img {
        width: 100%;
        margin-bottom: -16px;
    }
</style>